import React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import moment from "moment"
import { URL_DATE_FORMAT } from "src/containers/Calendar/constants"
import Calendar from "src/containers/Calendar"
import BaseLayout from "src/layouts/Base"
// import Event from "src/containers/Event"
import {
  CALENDAR_URL,
  CALENDAR_EVENT_URL,
  CALENDAR_DATE_URL,
  CALENDAR_REDIRECT_URL,
  EVENT_CALENDAR_UUID_VALIDATION_CONFIG,
} from "src/constants/routeNames"
import withRouteValidation from "src/hocs/withRouteValidation"
import NotFoundPage from "src/components/pages/NotFound"

const CalendarEvent = props => <Calendar {...props} />
// eslint-disable-next-line react/destructuring-assignment
// props.match.params.id !== `new` ? (
//   <Calendar {...props} />
// ) : (
//   <Event {...props} />
// )

export default (
  <Route path={CALENDAR_URL}>
    <BaseLayout title="Календарь">
      <Switch>
        <Route
          exact
          path={CALENDAR_EVENT_URL}
          component={withRouteValidation({
            routeValidationConfig: EVENT_CALENDAR_UUID_VALIDATION_CONFIG,
          })(CalendarEvent)}
          scale="month"
          date={`${moment().format(URL_DATE_FORMAT)}`}
        />
        <Route
          exact
          path={CALENDAR_DATE_URL}
          component={props =>
            moment(props.match.params.date, URL_DATE_FORMAT, true).isValid() ? (
              <Calendar
                {...props}
                scale={props.match.params.scale}
                date={props.match.params.date}
              />
            ) : (
              <NotFoundPage />
            )
          }
        />
        <Redirect from={CALENDAR_URL} to={CALENDAR_REDIRECT_URL} />
      </Switch>
    </BaseLayout>
  </Route>
)
